import * as React from 'react';

import { DataTable } from '@/components/dataTable';
import { useDataTable } from '@/components/dataTable/hooks/use-data-table';
import { DataTableToolbar } from '@/components/dataTable/ToolBar';

import { useConfirmationStore } from '@/components/dialog/confirmation.store';
import { useDialogFormStore } from '@/components/dialog/form.store';
import { useDynamicLocale } from '@/hoslog-intl';
import { Pagination } from '@/react-query/context/ApiClientContextController';
import { HoslogRequestPlans, PLAN_REQUEST_STATUS } from '@/services/hoslog-plans/hoslog-plans-request.types';
import useHoslogPlansRequestStatus from '../hooks/useHoslogPlansRequestStatus';
import { getColumns } from './Column';

export function PlanRequestsTable({
  data,
  pagination,
  isLoading = false,
}: {
  data: HoslogRequestPlans[];
  pagination: Pagination;
  isLoading: boolean;
}) {
  const { t } = useDynamicLocale();
  const { openConfirmation } = useConfirmationStore();
  const { onOpen } = useDialogFormStore();
  const { mutateAsync: togglePlanRequestStatus } = useHoslogPlansRequestStatus();

  const columns = React.useMemo(
    () => getColumns(onOpen, togglePlanRequestStatus, t, openConfirmation),
    [onOpen, togglePlanRequestStatus, t, openConfirmation],
  );
  const pageCount = React.useMemo(
    () => Math.ceil((pagination.totalItems ?? 0) / (pagination.pageSize ?? 1)),
    [pagination.totalItems, pagination.pageSize],
  );
  const { table, statusFilter, onStatusFilterChange } = useDataTable({
    data,
    columns,
    pageCount: pageCount,
    statusFilterKey: 'statusFilter',
    meta: {
      title: t('configurationManagement.plans.planRequest'),
      totalPage: pagination.totalItems,
      loading: isLoading,
    },
    getRowId: (originalRow) => String(originalRow.sno),
    shallow: false,
    clearOnDefault: true,
  });

  return (
    <>
      <DataTable table={table} className="rounded-t-none">
        <DataTableToolbar
          statusFilter={statusFilter as PLAN_REQUEST_STATUS}
          onStatusFilterChange={onStatusFilterChange}
        />
      </DataTable>
    </>
  );
}
